module.exports = __webpack_public_path__ + "static/media/vnPay_image.7c578b7d.png";